import { Component } from '@angular/core';
import { MiniLayoutWithText } from '@uigy/modules/mini-layout/models/mini-layout';
import { MiniLayoutWrapperComponent } from '@uigy/shared/components/mini-layout-wrapper/mini-layout-wrapper.component';
import { LanguageService } from '@uigy/shared/services/language.service';

@Component({
  selector: 'app-shut-down',
  templateUrl: './shut-down.component.html',
  imports: [
    MiniLayoutWrapperComponent,
  ],
})
export class ShutDownComponent {
  public text: MiniLayoutWithText = this.languageService.texts.mini_layout_pages.shutdown;
  constructor(private languageService: LanguageService) {
  }
}
